<div class="tree-card" [style.height]="data?.height || '52vh'">
  <div class="tree-body">

    <!-- ========== Mine header ========== -->
    <section class="mine-header" *ngIf="mineInfo.name">
      <h3 class="mine-name">{{ mineInfo.name }}</h3>

      <div class="mine-details" *ngIf="mineInfo.details.length">
        <div class="mine-detail-row" *ngFor="let d of mineInfo.details">
          <span class="detail-label">{{ d.label }}:</span>
          <span class="detail-value">{{ d.value }}</span>
        </div>
      </div>

      <div class="mine-note-row" *ngIf="mineNoteText">
        <span class="detail-label">Mine Background:</span>
        <span class="detail-value mine-note-text">{{ mineNoteText }}</span>
      </div>
    </section>

    <hr class="section-divider" />

    <!-- ========== Risk factors ========== -->
    <section class="risk-factors">
      <ng-container *ngFor="let rf of riskFactors">

        <!-- Header row (e.g. Repower Risk Level) -->
        <ng-container *ngIf="rf.isHeader">
          <div class="risk-row header-row">
            <span class="score-badge large" [ngClass]="getScoreClass(rf.score)">{{ getDisplayScore(rf) }}</span>
            <span class="risk-label bold">{{ rf.label }}</span>
          </div>
          <hr class="section-divider" />
        </ng-container>

        <!-- Normal row -->
        <div *ngIf="!rf.isHeader" class="risk-row" [class.clickable-row]="isFactorClickable(rf)" (click)="onFactorClick(rf)">
          <span *ngIf="showScoreBadge(rf)" class="score-badge" [ngClass]="getScoreClass(rf.score)">{{ getDisplayScore(rf) }}</span>
          <span *ngIf="!showScoreBadge(rf)" class="score-spacer" aria-hidden="true"></span>
          <span class="risk-label" [class.clickable]="isFactorClickable(rf) && rf.path && !canExpandFactor(rf)">{{ rf.label }}</span>
          <span *ngIf="canExpandFactor(rf)" class="expand-icon" (click)="toggleFactor(rf.label); $event.stopPropagation()">
            {{ isExpanded(rf.label) ? '-' : '+' }}
          </span>
        </div>

        <!-- Sub-factors (expanded) -->
        <div *ngIf="shouldShowSubFactors(rf)"
             class="sub-factors">
          <div *ngFor="let sub of rf.subFactors" class="risk-row sub-row" [class.sub-row-clickable]="sub.path" (click)="onSubFactorClick(rf, sub)">
            <span class="sub-arrow" *ngIf="!rf.hideSubArrows">-&gt;</span>
            <span class="risk-label sub-label" [class.multiline-label]="sub.multiline">{{ sub.label }}</span>
            <span class="sub-chevron" *ngIf="sub.path && !rf.hideSubArrows">&gt;</span>
          </div>
        </div>
      </ng-container>

      <!-- ========== Catastrophic Failure Flow ========== -->
      <ng-container *ngIf="catastrophicFeature.engineModels.length > 0">
        <div class="risk-row clickable-row" (click)="toggleCatastrophic()">
          <span class="score-badge" [ngClass]="getScoreClass(catastrophicFeature.score)">{{ getDisplayScore(catastrophicFeature) }}</span>
          <span class="risk-label" style="cursor: pointer;">{{ catastrophicFeature.label }}</span>
          <span class="expand-icon" (click)="toggleCatastrophic(); $event.stopPropagation()">
            {{ catastrophicFeature.isExpanded ? '-' : '+' }}
          </span>
        </div>

        <div *ngIf="catastrophicFeature.isExpanded" class="sub-factors">
          <div *ngFor="let eng of catastrophicFeature.engineModels" 
               class="risk-row sub-row sub-row-clickable" 
               (click)="onCatastrophicEngineClick(eng)">
            <span class="sub-arrow">-&gt;</span>
            <span class="risk-label sub-label">{{ eng.display }}</span>
            <span class="sub-chevron">&gt;</span>
          </div>
        </div>
      </ng-container>
    </section>

    <!-- ========== Opportunities ========== -->
    <section class="opportunities-section">
      <div class="opportunities-card">
        <p class="opportunities-title"><strong><u>Opportunities:</u></strong></p>
        <ul class="opportunities-list">
        </ul>
      </div>
    </section>

  </div>
</div>
